import { render, staticRenderFns } from "./RegionsMap.vue?vue&type=template&id=10789e4a&scoped=true&"
import script from "./RegionsMap.vue?vue&type=script&lang=js&"
export * from "./RegionsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10789e4a",
  null
  
)

export default component.exports